import * as React from "react";
import { useResponsivity } from "./store";
var debounceTimeout = null;
var throttleAndDebounceDelay = 100;
var throttleAndDebounceTimeout = 80;
var throttled = false;
var rootStyleSheet = null;
var resizeHandler = function (actions) {
    if (throttled) {
        return;
    }
    throttled = true;
    setTimeout(function () { return throttled = false; }, throttleAndDebounceDelay);
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(function () { return feed(actions); }, throttleAndDebounceTimeout);
};
var initStyle = function () {
    rootStyleSheet = document.querySelector(":root");
};
function feed(actions) {
    actions.setWindowDimension(window.innerWidth, window.innerHeight);
}
;
export var ResponsiveFeederElem = function () {
    var _a = useResponsivity(), actions = _a[1];
    React.useEffect(function () {
        window.addEventListener("resize", function () { return resizeHandler(actions); });
        initStyle();
        feed(actions);
        setTimeout(function () { return feed(actions); }, 100);
    }, []);
    return React.createElement(React.Fragment, null);
};
var FlexboxTestElem = function () {
    return React.createElement("div", { id: "gap_support_test_elem", style: { display: "none", flexDirection: "column", gap: "1px" } },
        React.createElement("div", null),
        React.createElement("div", null));
};
function TestGapSupport() {
    var flex = document.getElementById('gap_support_test_elem');
    if (flex) {
        flex.style.display = 'flex';
        var isSupported = flex.scrollHeight === 1;
        flex.style.display = "none";
        return isSupported;
    }
    return null;
}
var FlexboxTestAnalyzer = function () {
    var _a = useResponsivity(), actions = _a[1];
    React.useEffect(function () {
        var gap_support = TestGapSupport();
        if (gap_support !== null) {
            actions.setFlexGapSupport(gap_support);
        }
    }, []);
    return React.createElement(React.Fragment, null);
};
export var FlexboxTest = function () {
    return React.createElement(React.Fragment, null,
        React.createElement(FlexboxTestElem, null),
        React.createElement(FlexboxTestAnalyzer, null));
};
